import Head from "next/head";
import { GOKWIK_SCRIPT, KWIKPASS_MID, STORE_ENV } from "~/config";
import { removeHtmlTags } from "~/utils/helper";

function NextHead({
  siteName,
  title,
  description = "",
  image,
  canonical,
  googleVerificationTag,
  noIndex,
}) {
  return (
    <Head>
      <meta charSet="UTF-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover, user-scalable=no, shrink-to-fit=no"
      />
      <meta name="HandheldFriendly" content="true" />
      {!!googleVerificationTag && (
        <meta name="google-site-verification" content={googleVerificationTag} />
      )}

      <link rel="canonical" href={canonical} />
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={removeHtmlTags(description)} />
      <meta name="keywords" content={siteName} />
      {noIndex && <meta name="robots" content="noindex" />}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} key="ogtitle" />
      <meta
        property="og:description"
        content={removeHtmlTags(description)}
        key="ogdesc"
      />
      <meta property="og:url" content={canonical} />
      {!!image && <meta property="og:image" content={image} />}

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={title} />
      <meta
        property="twitter:description"
        content={removeHtmlTags(description)}
      />
      {!!image && <meta property="twitter:image" content={image} />}

      {!!GOKWIK_SCRIPT && <script defer src={GOKWIK_SCRIPT} />}
      <script
        dangerouslySetInnerHTML={{
          __html: `
              window.merchantInfo = {
                environment: '${
                  STORE_ENV === "production" ? "production" : "sandbox"
                }',
                mid: '${KWIKPASS_MID}',
                type: "merchantInfo"
              };
            `,
        }}
      />
    </Head>
  );
}

export default NextHead;
